import { Component, Input, OnDestroy, OnInit } from '@angular/core';
//import { AddressService } from 'src/app/Shared/Services/address.service';
//import { eventManagerService } from 'src/app/Shared/Services/eventmanager.service';
import * as _ from 'lodash';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
//import { OnboardingService } from 'src/app/Shared/Services/onboarding.service';
import { ActivatedRoute } from '@angular/router';
import moment from "moment";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { NgForm } from '@angular/forms';
import { NbcLoggerService } from '../../../shared/logger/nbc-logger.service';
import { EventBusService, EmitEvent } from '../../../core/services/event-bus.service';
import { BusinessUnitService } from '../../../shared/services/business-unit.service';
import { OnboardingService } from '../../../shared/services/onboarding.service';


@Component({
    selector: 'app-position-request',
    templateUrl: './position-request.component.html',
    standalone: false
})
export class PositionRequestComponent implements OnInit, OnDestroy {
  constructor(
    private _onboardingService: OnboardingService,
    private _businessUnitService: BusinessUnitService,
    public _bsModalRef: BsModalRef,
    private activatedRoutes: ActivatedRoute,
    private _eventBus: EventBusService,
    public options: ModalOptions,
    private log: NbcLoggerService
  ) {
    this.modelValue = this.options.initialState;
  }

  
  public onSync!: Subject<any>;
  public onCancelSync!: Subject<any>;
  user: any = window.preload?.user;
  date: any;
  frmPositionRequest: any;
  reportsToManager: any;
  isSaveDisabled = false;
  isRequiredValidation = true;
  isPositionStartDateInvalid = false;
  positionStartDate: any;
  broadcastingDates: any
  countries: any;
  productionManagers:any[] = [];
  proxyList: any[] = [];
  submitted: any;
  positionRequestsLength: any;
  positionDetails: any = {
    hiringManagerId: 0,
    businessUnit: {},
    proxy: {},
    reportTo: {},
    companyCode: {},
    positionStartDate: "",
    employeeType: {},
    flasstatus: {},
    state: {},
    sappositionNo: "",
    onboardingStatus: {}
  };
  contactDetails: any;
  contact: any;
  companyCode: any;
  postionType: any
  countryCode = "US";
  proxyEmail = "";
  proxy: any;
  scheduleDates: any;
  private subs = new SubSink();
  state: any;
  disableFlsaStatus = true;
  flsaStatus: any;
  positionRequests: any | undefined;
  hiringManger = null;
  positionRequestsResult: any;
  modelValue: any;
  businessUnit: any;
  businessUnits: any = [];
  proxiesList: any = [];
  stateList: any = [];
  onboardingMasterData: any[] = [];
  
  getBusinessUnits() {
    this.subs.sink = this._businessUnitService.get().subscribe({
      next: (result) => {
        this.businessUnits = result.reference;
        console.log(this.businessUnits);
      },
      error: (err) => {
        this.log.showError("Business Units failed to load");
      },
    });
  }

  getMasterData() {
    this.subs.sink = this._onboardingService.getOnboardingMasterData().subscribe({
      next: (result) => {
        this.onboardingMasterData = result.reference;
        this.stateList = result.reference.states;
        const state = this.stateList?.find(s => s.code.toUpperCase() === this.contact.province?.toUpperCase());
        if (state) {
          this.state = state.code;
        } else { this.state = null; }
        console.log(result.reference);
        console.log(result.reference.companyCodes);
      },
      error: (err) => {
        this.log.showError("Business Units failed to load");
      },
    });
  }



  savePositionRequest(frmPositionRequest: NgForm) {
    this.submitted = true;
    if (frmPositionRequest.valid && this.validateCustomControls()) {
      this.submitRequest();   
    }
    
  }
  validateCustomControls() {
    return (this.companyCode
      && this.postionType
      && this.state
      && this.businessUnit
      && this.reportsToManager
      && this.flsaStatus
      && this.positionStartDate
    )
  }

  proxySelected(selectedProxy) {
    if (selectedProxy)
      this.proxyEmail = selectedProxy?.name;
    else
      this.proxyEmail = "";
  }
   
  modalCancel() {
    this.log.trace("canceled total modal");
    this.onCancelSync.next(false);
    this._bsModalRef.hide();
  };

  submitRequest() {

    if (this.contact?.id == this.proxy?.id) {
      this.log.showModalError("Contact and Proxy cannot be the same. Please choose a different Proxy.")
      return;
    }

    this.positionDetails.scoreId = this.contact.id;
    this.positionDetails.hiringManagerId = window.preload?.user?.contactId;
    this.positionDetails.businessUnitId = this.businessUnit?.id;
    this.positionDetails.businessUnitName = this.businessUnit?.description;
    this.positionDetails.proxy = this.proxy;
    this.positionDetails.reportTo = this.reportsToManager;
    this.positionDetails.companyCode = this.companyCode;
    this.positionDetails.positionStartDate = moment(this.positionStartDate).format("MM/DD/yyyy"); 
    this.positionDetails.employeeType = this.postionType;
    const state = this.stateList?.find(s => s.code.toUpperCase() === this.state.toUpperCase());
    this.positionDetails.state = state?.name;
    this.positionDetails.onboardingStatus = "Request Submitted";
    this.positionDetails.flsastatus = this.flsaStatus;
    this.positionDetails.onboardingContact = this.contact;
    this.subs.sink = this._onboardingService.saveOnboardingPositionRequests(this.positionDetails)
        .subscribe(
        {
          next: (result) => {
            this.positionRequestsResult = result.reference;
            this.onSync.next(this.positionRequestsResult);
            this._bsModalRef.hide();
            this.submitted = false;
          },
          error: (err) => {
            this.log.error("got an error: " + JSON.stringify(err));
            this.log.showModalError("Unable to submit the Position Request.")
          }
        });
  }
   
  ngOnInit() {
    this.onSync = new Subject();
    this.onCancelSync = new Subject();
    this.positionStartDate = moment(new Date(), "MM/DD/YYYY").toDate();
    this.contact = this.modelValue.contactDetails;
    this.getBusinessUnits();
    this.hiringManger = window.preload.user?.firstName + " " + window.preload.user?.lastName;
    this.getMasterData();
    
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



